import { Flex, Typography } from "antd";
import Image from "next/image";
import { useIntl } from "react-intl";
import { _eventBus } from "../../core/events/EventBus";
import { evtTree } from "../../Orchestrator/ConstantTree";

const DailyCommuter = ({ }: any) => {
  const intl = useIntl();

  const handleBookNow = () => {
    _eventBus.emit({
      eventName: evtTree.MultiBookNow.Click,
    });
  }

  return (
    <div>
      <Typography.Title className="daily-commuter-text" level={3}>
        {intl.formatMessage({ id: "dailyCommuterText" })}
      </Typography.Title>
      <Flex wrap className="commuter">
        <div>
          <div className="align-items-center">
            <Image
              src="/assets/booking/10-per-dis.png"
              alt="10% Discount"
              className={intl.locale === "ar" ? "ten-per-disc" : ""}
              width={150.37}
              height={117.84}
            />
          </div>
        </div>
        <Flex wrap justify="space-between" align="center" className="flex-auto p-20">
          <div>
            <Typography.Title className="fs-20 fw-700 ff-inter" level={3}>
              {intl.formatMessage({ id: "get10PerDisText" })}
            </Typography.Title>
            <Typography.Title
              className="fs-18 fw-400 mt-0 ff-inter color-757575"
              level={3}
            >
              {intl.formatMessage({ id: "unlockMultiBookingText" })}
            </Typography.Title>
          </div>
          <div className="p-20 ml-auto">
            <div className="align-items-center justify-content-center">
              <Typography.Title
                className="activate-multi-text"
                level={3}
                onClick={() => handleBookNow()}
              >
                <span className="mr-10">
                  {intl.formatMessage({ id: "offer.bookNow" })}
                </span>
                <Image
                  src="/assets/booking/expand_more.svg"
                  width={14}
                  height={14}
                  alt="multi booking"
                  className={intl.locale === "ar" ? "activate-arrow" : ""}
                />
              </Typography.Title>
            </div>
          </div>
        </Flex>
      </Flex>
    </div>
  );
};

export default DailyCommuter;
